import { constants } from "@newsela/angelou";

const { colors } = constants;
const grey = colors.ui.neutral[500];
const neutral700 = colors.ui.neutral[700];

export const cardWrapper = (disabled: boolean) => ({
  position: "relative" as const,
  display: "flex",
  flexDirection: "column" as const,
  gap: 16,
  padding: 24,
  opacity: disabled ? ".5" : 1,
});

export const titleCss = {
  textTransform: "uppercase" as const,
  fontSize: 12,
  fontWeight: 700,
  color: grey,
  margin: 0,
  textAling: "center",
};

export const headerCss = {
  margin: 0,
};

export const textCss = {
  margin: 0,
};

export const answerWrapper = {
  display: "flex",
  position: "relative" as const,
  marginTop: "8px",
  padding: "12px 16px",
  flexDirection: "column" as const,
  alignItems: "flex-start",
  gap: "10px",
  borderRadius: "4px",
  background: "rgba(15, 134, 112, 0.15)",
};

export const indicatorWrapper = {
  position: "absolute" as const,
  top: -10,
  left: 10,
};

export const divider = {
  height: "1px;",
  flexShrink: 0,
  alignSelf: "stretch",
  opacity: "0.16",
  background: neutral700,
  position: "absolute" as const,
  width: "100%",
  bottom: 0,
  left: 0,
};

export const reportButtonCss = {
  display: "flex",
  alignSelf: "center",
  padding: "8px 16px",
  cursor: "pointer",
};

export const footWrapper = {
  display: "flex",
  flexDirection: "row" as const,
  justifyContent: "space-between" as const,
  alignItems: "center" as const,
};

export const buttonsWrapper = {
  display: "flex",
  flexDirection: "row" as const,
};

export const questionCss = {
  display: "flex",
  alignItems: "center",
  h4: {
    marginRight: "4px",
  },
};
